import { render, staticRenderFns } from "./content_warship.vue?vue&type=template&id=b953209c&scoped=true&"
import script from "./content_warship.vue?vue&type=script&lang=js&"
export * from "./content_warship.vue?vue&type=script&lang=js&"
import style0 from "./content_warship.vue?vue&type=style&index=0&id=b953209c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953209c",
  null
  
)

export default component.exports